import uniqid from "uniqid";

import TopLine from "../common/TopLine";
import List from "../common/List/List";
import TitleCell from "../common/List/TitleCell";
import ProblemRow from "./ProblemRow";
import { useState } from "react";
import ProblemPopUp from "./ProblemPopUp";

const ProblemList = ({ problems, setProblems }) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const [curProblem, setCurProblem] = useState(null);

  const titles = [
    "回報時間",
    "會員編號",
    "住戶姓名",
    "房號",
    "回報標題",
    "案件狀態",
    "回報內容",
    "備註",
  ];

  return (
    <div>
      <TopLine />
      {showPopUp ? (
        <ProblemPopUp
          problem={curProblem}
          setShowPopUp={setShowPopUp}
          setProblems={setProblems}
        />
      ) : (
        <></>
      )}
      <List gridCols="grid-cols-[repeat(6,min-content)_1fr_1fr]">
        {titles.map((text) => (
          <TitleCell
            key={uniqid()}
            text={text}
            className="whitespace-nowrap px-2"
          />
        ))}
        {problems.map((problem) => (
          <ProblemRow
            key={uniqid()}
            problem={problem}
            setCurProblem={setCurProblem}
            setShowPopUp={setShowPopUp}
          />
        ))}
      </List>
    </div>
  );
};

export default ProblemList;
